var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plat-student-info"},[_c('PlatStudentInfoDashboard',_vm._g(_vm._b({attrs:{"student-id":_vm.rowData.id}},'PlatStudentInfoDashboard',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }